/* eslint-disable react/require-default-props */
import React, { useEffect, useMemo, useState } from 'react';
import './TooltipText.scss';
function TooltipText({ text, children, position = 'top', delay = 200 }) {
    const [isVisible, setIsVisible] = useState(false);
    const [timeoutId, setTimeoutId] = useState(null);
    useEffect(() => {
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [timeoutId]);
    const tooltipId = useMemo(() => `tooltip-${Math.random().toString(36).substr(2, 9)}`, []);
    const handleMouseEnter = () => {
        const id = setTimeout(() => {
            setIsVisible(true);
        }, delay);
        setTimeoutId(id);
    };
    const handleMouseLeave = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            setTimeoutId(null);
        }
        setIsVisible(false);
    };
    return (React.createElement("div", { className: "tooltipText__container", onMouseEnter: handleMouseEnter, onMouseLeave: handleMouseLeave, "aria-describedby": isVisible ? `tooltip-${tooltipId}` : undefined },
        children,
        isVisible && (React.createElement("div", { className: `tooltipText__content tooltipText__content--${position}`, "aria-live": "polite" }, text))));
}
export default TooltipText;
